import React, { useContext, useEffect, useLayoutEffect, useRef } from 'react'
import { Box } from '@chakra-ui/react'
import { LayoutContext } from './Layout'

export const LayoutOverlay = ({ showOverlay = false, ...rest }) => {
  const highlightedRef = useRef(null)
  const highlightPosition = useRef({ left: 0, top: 0 })
  const { highlightElement } = useContext(LayoutContext)

  // useEffect(() => {
  //   window.addEventListener('scroll', e => e.preventDefault())
  //   return () => {
  //     window.removeEventListener('scroll', e => e.preventDefault())
  //   }
  // }, [])

  useLayoutEffect(() => {
    if (!highlightElement) return
    if (!showOverlay) return

    const layoutOverlayPortal = document.getElementById('layout-overlay-portal')

    highlightPosition.current = getOffset(highlightElement)

    const highlightElementRefClone = highlightElement.cloneNode(true)
    highlightedRef.current = highlightElementRefClone

    layoutOverlayPortal.appendChild(highlightElementRefClone)
  }, [showOverlay, highlightElement])

  useEffect(() => {
    if (!showOverlay && highlightedRef.current) {
      const layoutOverlayPortal = document.getElementById(
        'layout-overlay-portal',
      )
      layoutOverlayPortal.innerHTML = ''
    }
  }, [showOverlay])

  return (
    <Box
      left="0"
      right="0"
      bottom="0"
      top="0"
      position="fixed"
      zIndex={2000}
      w="100vw"
      background="blackAlpha.500"
      opacity={showOverlay ? 1 : 0}
      height={showOverlay ? document.body.scrollHeight : 1}
      {...rest}
    >
      <Box
        position="absolute"
        left={highlightPosition.current.left}
        top={highlightPosition.current.top}
        id="layout-overlay-portal"
      />
    </Box>
  )
}

function getOffset(el) {
  if (!el) return
  const rect = el.getBoundingClientRect()
  const posX = rect.left + window.scrollX
  const posY = rect.top + window.scrollY
  return { left: posX, top: posY, width: rect.width, height: rect.height }
}
